import { render, staticRenderFns } from "./MdRadioGroup.vue?vue&type=template&id=e804440a&"
import script from "./MdRadioGroup.vue?vue&type=script&lang=js&"
export * from "./MdRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports